import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { Users, Target, Heart } from 'lucide-react';

export function AboutPage() {
  const { t } = useLanguage();

  const values = [
    {
      icon: Users,
      title: 'about.values.professionalism.title',
      description: 'about.values.professionalism.description',
    },
    {
      icon: Target,
      title: 'about.values.reliability.title',
      description: 'about.values.reliability.description',
    },
    {
      icon: Heart,
      title: 'about.values.excellence.title',
      description: 'about.values.excellence.description',
    },
  ];

  return (
    <div className="bg-white">
      <div className="max-w-7xl mx-auto py-16 px-4 sm:px-6 lg:px-8">
        <div className="text-center">
          <h1 className="text-4xl font-extrabold text-gray-900 sm:text-5xl">
            {t('about.title')}
          </h1>
          <p className="mt-4 text-xl text-gray-600">
            {t('about.subtitle')}
          </p>
        </div>

        <div className="mt-20">
          <div className="grid grid-cols-1 gap-12 lg:grid-cols-3">
            {values.map(({ icon: Icon, title, description }) => (
              <div key={title} className="text-center">
                <div className="flex justify-center">
                  <Icon className="h-12 w-12 text-blue-900" />
                </div>
                <h3 className="mt-4 text-xl font-semibold text-gray-900">
                  {t(title)}
                </h3>
                <p className="mt-2 text-gray-600">
                  {t(description)}
                </p>
              </div>
            ))}
          </div>
        </div>

        <div className="mt-20">
          <h2 className="text-3xl font-extrabold text-gray-900 text-center">
            {t('about.history.title')}
          </h2>
          <div className="mt-8 prose prose-blue mx-auto">
            <p className="text-lg text-gray-600">
              {t('about.history.content')}
            </p>
          </div>
        </div>

        <div className="mt-20">
          <h2 className="text-3xl font-extrabold text-gray-900 text-center">
            {t('about.mission.title')}
          </h2>
          <p className="mt-4 text-lg text-gray-600 text-center max-w-3xl mx-auto">
            {t('about.mission.content')}
          </p>
        </div>
      </div>
    </div>
  );
}